import React, { useEffect } from "react";
import "./Style.css";
import "./Components/Common/Utils.scss";
import "./Components/Guest/Guest.css";

import { Provider } from "react-redux";
import store, { persistor } from "./Redux/store";

import Home from "./Home";
import { BrowserRouter } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistGate } from "redux-persist/integration/react";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {}, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Home />
          </BrowserRouter>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
